import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ReportManagerService } from '../../services/report-manager.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { ReportList } from 'src/app/Modules/informate/models/reports/data-sheet-report.model';
@Component({
    selector: 'app-reports-content',
    templateUrl: './reports-content.component.html',
    styleUrls: ['./reports-content.component.scss'],
})
export class ReportsContentComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    cardBodyMessage: string = 'mainCard';
    // private selectedReportNamesubscription: Subscription;
    reportName: string;
    reportId: string;
    supportedFileTypes: [];
    currentReport: ReportList;
    constructor(private reportManagerService: ReportManagerService) {}

    ngOnInit(): void {
        this.reportManagerService.isReportSelected.next(this.cardBodyMessage);
        this.reportManagerService.isReportSelected.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.cardBodyMessage = res;
            }
        });

        this.reportManagerService._selectedView.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
            if (res) {
                this.reportName = res.reportName;
                this.cardBodyMessage = res.type;
                this.supportedFileTypes = res.supportedFileTypes;
                this.reportManagerService.selectedReportName.next(res.reportName);
                this.reportId = res.reportId;
                this.reportManagerService._selectedView.next(null);
                this.currentReport = res;
            }
        });
    }

    ngOnDestroy(): void {
        // if (this.selectedReportNamesubscription) this.selectedReportNamesubscription.unsubscribe();
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
